import React from "react";
import styled from "styled-components";

import About2 from "../../images/banner123.jpg";
import ownerimg from "../../images/owner-img.JPG";
// import ownerwifeimg from "../../images/wife of owner.png";
import ownerwifeimg from "../../images/OwnerWife.jpeg";

const AboutSection = () => {
  return (
    <>
      <Container>
      <section id="about" >
      <div className="container">
{/* <div className="heading text-center">
  
  <h1>Welcome to Aysuhi Construction About Us Page</h1>
  <div
                className="underline mx-auto"
                style={{
                  height: 3,
                  width: "4rem",
                  backgroundColor: "#34495E",
                  marginTop: 20,
                  marginBottom: 10,
                }}
              ></div>
</div> */}






        {/* <div className="row align-items-center mt-3">
        <div className="col-lg-6 mt-2" id='desktop'>
            <div className="about-content s-about-content pl-30  " data-aos= "fade-right">
              <div className="about-title second-atitle">
             
                <h2>Welcome To Ayushi Construction</h2>
                <p><span></span>We provide an essential support for you</p>
              </div>
              <p>With extensive expertise in the field of real estate, Ayushi Construction Developers provides top-tier housing solutions and undertakes the construction of residential, commercial, and industrial buildings. Our services extend to comprehensive infrastructural works, ensuring robust and sustainable development.</p>
              <ul className="list-item">
                <li><span>Residential Construction</span>: We create beautiful, functional, and durable homes that cater to diverse needs and preferences.</li>
                <li><span>Commercial Projects</span>: From office spaces to retail establishments, we deliver commercial buildings designed for success and growth.</li>
                <li>
                <span>Industrial Buildings</span>: Our industrial construction projects are built to support operational efficiency and long-term resilience.

                </li>
                <li>
                <span>Infrastructural Works</span>: We specialize in developing essential infrastructure, including roads, bridges, and utility systems, to support thriving communities.
                </li>
              </ul>
              <button  className="btn" style={{color:"white" ,backgroundColor:"  color: #01614e;"}}>Get Started</button>
            </div>
          </div>
       
          <div className="col-lg-6" id='desktop'>
            <div className="s-about-img p-relative" data-aos= "fade-left">
              <img src= {About2} alt="img" />
              
            </div>
          </div>
          <div className="col-lg-6"  id='mobile'>
            <div className="s-about-img p-relative" data-aos= "fade-left">
              <img src= {About2} alt="img" />
              
            </div>
          </div>

          <div className="col-lg-6 mt-2" id='mobile'>
            <div className="about-content s-about-content pl-30  " data-aos= "fade-right">
              <div className="about-title second-atitle">
                
                <h2>Welcome To Ayushi Construction</h2>
                <p><span></span>We provide an essential support for you</p>
              </div>
              <p>With extensive expertise in the field of real estate, Ayushi Construction Developers provides top-tier housing solutions and undertakes the construction of residential, commercial, and industrial buildings. Our services extend to comprehensive infrastructural works, ensuring robust and sustainable development.</p>
              <ul className="list-item">
                <li><span>Residential Construction</span>: We create beautiful, functional, and durable homes that cater to diverse needs and preferences.</li>
                <li><span>Commercial Projects</span>: From office spaces to retail establishments, we deliver commercial buildings designed for success and growth.</li>
                <li>
                <span>Industrial Buildings</span>: Our industrial construction projects are built to support operational efficiency and long-term resilience.

                </li>
                <li>
                <span>Infrastructural Works</span>: We specialize in developing essential infrastructure, including roads, bridges, and utility systems, to support thriving communities.
                </li>
              </ul>
              <button  className="btn" style={{color:"white" ,backgroundColor:"  color: #01614e;"}}>Get Started</button>
            </div>
          </div>
          
        </div> */}
        <h2 className="text-center mt-5">DIRECTOR’S OF AYUSHI CONSTRUCTION</h2>
        <div
                className="underline mx-auto"
                style={{
                  height: 3,
                  width: "4rem",
                  backgroundColor: "#34495E",
                 
                }}
              ></div>
              <p className="mt-3">
              Welcome to Ayushi Construction, one of the reputed leading home builders in Jabalpur established in 2006, by Satyendra . We specialize in creating comfortable and affordable residential homes that cater to your needs. Our latest completed projects Rudraksh Park, 
Ayushi Palm Green, 
Ayushi Villa, 
Ayushi Dhara,
Ayushi Dhara Phase-I, 
Ayushi Hari Vihar Phase-I in Jabalpur, offers 2/3 BHK Flats/Apartments with state-of-the-art architecture and a wide range of amenities to provide a comfortable living experience. Additionally, we have ongoing projects like Ayushi Home,
Shiv Malti Vihar Ayushi Dhara Phase-II,
Ayushi Dhara Phase-III,
Ayushi Dhara Phase-IV,
Ayushi Dhara Phase-V,
Ayushi Hari Vihar Phase-II,
Ayushi Vrindavan.

</p>
        <div className="row align-items-center mt-3">
<div className="col-lg-6" id="desktop">
            <div className="s-about-img p-relative" data-aos= "fade-right">
              <img src= {ownerimg} alt="img" />
              
            </div>
            
          </div>
<div className="col-lg-6" id="desktop">
           
            <div className="s-about-img p-relative" data-aos= "fade-left">
              <img src= {ownerwifeimg} alt="img" />
              
            </div>
          </div>

        <div className="col-lg-6 mt-2" id="desktop">
            <div className="about-content s-about-content pl-30  " data-aos= "fade-right">
              <div className="about-title second-atitle">
               
             
                <h5><span>SATYENDRA YADAV</span>
                </h5>
              </div>
              <p>Satyendra Yadav, the Director of Ayushi Construction, which is the best construction company in Jabalpur, is a seasoned professional with a decade of experience in land acquisition and development. His expertise lies in colonizing and developing townships, making him a valuable asset to the company.
              </p>
              <p>Under Satyendra’s leadership, Ayushi Construction has successfully completed several real estate projects, including Rudraksh Park and Ayushi Palm Greens in Ganga Nagar, Jabalpur, and Ayushi Homess. These projects have not only met the expectations of the clients but have also become landmarks in their respective locations.
              </p>
              <p>Satyendra’s dedication and vision have played a crucial role in the success of these projects. He possesses a deep understanding of the real estate market and has the ability to identify lucrative opportunities for development. His strategic decision-making and meticulous planning have ensured that each project is executed flawlessly, resulting in high-quality residential properties of Ayushi Construction.
              </p>
   
            
            </div>
          </div>
        <div className="col-lg-6 mt-2" id="desktop">
            <div className="about-content s-about-content pl-30  " data-aos= "fade-left">
              <div className="about-title second-atitle">
               
             
                <h5><span>PUSHPA YADAV</span>
                </h5>
              </div>
              <p>Pushpa Yadav, the Partner of Ayushi Construction, is a dedicated professional with a keen eye for excellence and a passion for real estate development. As a key figure in the company's success, Pushpa plays an integral role in ensuring that Ayushi Construction maintains its reputation as the best construction company in Jabalpur.
              </p>
              <p>Working alongside Satyendra Yadav, Pushpa has contributed significantly to the successful completion of prominent projects like Rudraksh Park, Ayushi Palm Greens in Ganga Nagar, Jabalpur, and Ayushi Homess. Her collaborative approach and commitment to delivering high-quality residential properties have been instrumental in establishing Ayushi Construction as a trusted name in the industry.
              </p>
              <p>Pushpa Yadav’s vision and dedication are reflected in the company’s consistent growth and ability to meet client expectations. Her expertise in planning and executing real estate projects, combined with her unwavering determination, continues to drive Ayushi Construction toward new heights of success.
              </p>
   
            
            </div>
          </div>

<div className="col-lg-6" id="mobile">
            <div className="s-about-img p-relative" data-aos= "fade-right">
              <img src= {ownerimg} alt="img" />
              
            </div>
            
          </div>

          <div className="col-lg-6 mt-2" id="mobile">
            <div className="about-content s-about-content pl-30  " data-aos= "fade-right">
              <div className="about-title second-atitle">
               
             
                <h5><span>SATYENDRA YADAV</span>
                </h5>
              </div>
              <p>Satyendra Yadav, the Director of Ayushi Construction, which is the best construction company in Jabalpur, is a seasoned professional with a decade of experience in land acquisition and development. His expertise lies in colonizing and developing townships, making him a valuable asset to the company.
              </p>
              <p>Under Satyendra’s leadership, Ayushi Construction has successfully completed several real estate projects, including Rudraksh Park and Ayushi Palm Greens in Ganga Nagar, Jabalpur, and Ayushi Homess. These projects have not only met the expectations of the clients but have also become landmarks in their respective locations.
              </p>
              <p>Satyendra’s dedication and vision have played a crucial role in the success of these projects. He possesses a deep understanding of the real estate market and has the ability to identify lucrative opportunities for development. His strategic decision-making and meticulous planning have ensured that each project is executed flawlessly, resulting in high-quality residential properties.
              </p>
   
            
            </div>
          </div>
<div className="col-lg-6" id="mobile">
           
            <div className="s-about-img p-relative" data-aos= "fade-left">
              <img src= {ownerwifeimg} alt="img" />
              
            </div>
          </div>

        
        <div className="col-lg-6 mt-2" id="mobile">
            <div className="about-content s-about-content pl-30  " data-aos= "fade-left">
              <div className="about-title second-atitle">
               
             
                <h5><span>PUSHPA YADAV</span>
                </h5>
              </div>
              <p>Pushpa Yadav, the Partner of Ayushi Construction, is a dedicated professional with a keen eye for excellence and a passion for real estate development. As a key figure in the company's success, Pushpa plays an integral role in ensuring that Ayushi Construction maintains its reputation as the best construction company in Jabalpur.
              </p>
              <p>Working alongside Satyendra Yadav, Pushpa has contributed significantly to the successful completion of prominent projects like Rudraksh Park, Ayushi Palm Greens in Ganga Nagar, Jabalpur, and Ayushi Homess. Her collaborative approach and commitment to delivering high-quality residential properties have been instrumental in establishing Ayushi Construction as a trusted name in the industry.
              </p>
              <p>Pushpa Yadav’s vision and dedication are reflected in the company’s consistent growth and ability to meet client expectations. Her expertise in planning and executing real estate projects, combined with her unwavering determination, continues to drive Ayushi Construction toward new heights of success.
              </p>
   
            
            </div>
          </div>
        <div className="col-lg-12 mt-3" id="mobile">
            <div className="about-content s-about-content pl-30  " data-aos= "fade-right">
            
              <p>In addition to his past achievements, Satyendra is currently working on two incredible ongoing projects – Ayushi Dhara and Ayushi Villa. These projects are set to redefine luxury living and set new benchmarks in the real estate industry. With his expertise and innovative ideas, Satyendra aims to create exceptional living spaces that cater to the evolving needs and aspirations of modern homebuyers.
              </p>
              <p>Satyendra’s commitment to excellence and his passion for creating sustainable communities make him a respected figure in the real estate sector. He believes in delivering projects that not only provide comfortable living spaces but also contribute to the overall development of the surrounding areas.
              </p>
              <p>With his extensive experience and profound knowledge, Satyendra Yadav has established himself as a trusted name in the real estate industry. Under his guidance, Ayushi Construction continues to thrive and deliver exceptional projects that exceed the expectations of its customers.
              </p>
              <p>As the Director of Ayushi Construction, Satyendra Yadav is a driving force behind the company’s success and its commitment to creating exceptional living spaces that stand the test of time. His dedication to excellence and his ability to transform visions into reality make him an invaluable asset to the company and a true leader in the field of real estate.
              </p>
   
            
            </div>
          </div>

          

         
          
        </div>
      </div>
    </section>
      </Container>
    </>
  );
};

export default AboutSection;

const Container = styled.div`
img{
  width: 100%;
  height: 28rem;
  @media screen and (max-width: 768px) {
      height: 20rem;
      margin-top: 1rem;
      
    }
  @media screen and (min-width: 768px) and (max-width: 1024px) {
height: 32rem;
  }
}
h1{

  color: #f26a20;
  /* color: #d29b33; */
  
}
h2{


  color:#f26a20;
  
}
li{
  margin-top: 1rem;
}
span{
  font-weight: bold;
}
p{
  text-align: justify;
  
  }
  #mobile {
    display: none;

    @media screen and (min-width: 768px) and (max-width: 1024px)  {
      display: block;
    }
  }

  #desktop {
    @media screen and (min-width: 768px) and (max-width: 1024px) {
      display: none;
    }
  }
  #about{
  margin-top: 2.5rem;
  @media screen and (max-width: 768px) {
            margin-top:1rem;
            
      }
  @media screen and (min-width: 768px) and (max-width: 1024px) {
            margin-top:1rem;
            
      }
}
#mobile {
   display:none;
    
    @media screen and (max-width: 768px) {
      display: block;
    }
    @media screen and (min-width: 768px) and (max-width: 1024px)  {
      display: block;
    }
  }

  #desktop {
    display: block;
    @media screen and (max-width: 768px) {
      display: none;
    }
    @media screen and (min-width: 768px) and (max-width: 1024px) {
      display: none;
    }
  }
  p{
    text-align: justify;
  }
`;
